import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
    data() {
        return {
            opened: false
        };
    }
})
export default class ErrorModal extends Vue {
    @Prop(Boolean)
    value: boolean;

    @Prop()
    message: string;

    opened: boolean;

    @Watch('value')
    onChangeValue(value: boolean) {
        this.opened = value;
    }

   @Watch('opened')
    onChangeOpened(value) {
        this.$emit('input', value);
    }

   close() {
       this.opened = false;
   }
}
